import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnButton } from "@/components/VnButton/VnButton";
import { I18nKeyType } from "@/i18n";

import { BackButton } from "./BackButton";

type BottomNavigatorPropsType = {
  shouldShowBackButton?: boolean;
  shouldShowNextButton?: boolean;
  onBackButtonPress?: () => void;
  onNextButtonPress?: () => void;
  isNextButtonLoading?: boolean;
  isNextButtonDisabled?: boolean;
  nextButtonI18nKey?: I18nKeyType;
};

export const BottomNavigator: FC<BottomNavigatorPropsType> = ({
  shouldShowBackButton = true,
  shouldShowNextButton = true,
  onBackButtonPress,
  onNextButtonPress,
  isNextButtonLoading,
  isNextButtonDisabled,
  nextButtonI18nKey = "common:next",
}) => {
  return (
    <VnBox className="border-border bg-background items-center justify-center border-t px-5 py-4">
      <VnBox className="mx-auto w-full max-w-lg flex-row justify-between">
        {shouldShowBackButton ? (
          <BackButton variant="ghost" onPress={onBackButtonPress} />
        ) : (
          <VnBox className="h-9" />
        )}
        {shouldShowNextButton ? (
          <VnButton
            i18nKey={nextButtonI18nKey}
            onPress={onNextButtonPress}
            isLoading={isNextButtonLoading}
            isDisabled={isNextButtonDisabled}
          />
        ) : (
          <VnBox className="h-9" />
        )}
      </VnBox>
    </VnBox>
  );
};
